import React from 'react';
import therteen from './13.svg';
import therteen2 from './12.svg';
import therteen3 from './11.svg';
import therteen4 from './10.svg';
import therteen5 from './9.svg';
import therteen6 from './8.svg';
import therteen7 from './7.svg';
import therteen8 from './6.svg';
import therteen9 from './5.svg';

const features = [
  {
    title: 'On-Site Billing',
    desc: "Generate invoices instantly at your customer's location. Speed up billing cycles and eliminate the hassle of manual back-office entry.",
    icon: therteen9,
  },
  {
    title: 'Route Wise Stock',
    desc: 'Get a clear view of stock levels for each route. Ensure timely replenishment and meet customer demand without overstocking.',
    icon: therteen8,
  },
  {
    title: 'Route Account Balance',
    desc: 'Monitor balances and transactions for each route. Gain full financial visibility with effortless tracking of payments and outstanding dues.',
    icon: therteen7,
  },
  {
    title: 'Route Party Wise Balance',
    desc: 'Drill down into balances for individual customers on a route. Simplify accounts receivable management and streamline collections.',
    icon: therteen6,
  },
  {
    title: 'Cash Collection',
    desc: 'Record cash payments during route visits. Instantly update accounts and reduce the risk of missed or delayed entries.',
    icon: therteen5,
  },
  {
    title: 'Credit Billing',
    desc: 'Easily manage credit customers. Set limits, define payment terms, and track outstanding balances with complete control.',
    icon: therteen4,
  },
  {
    title: 'Route Wise Issue Material',
    desc: 'Distribute materials or products to specific routes with precision. Ensure optimal stock allocation and smooth order fulfillment.',
    icon: therteen3,
  },
  {
    title: 'Dashboard',
    desc: 'Gain real-time business insights through a powerful, centralized dashboard. Track sales, payments, inventory, and KPIs at a glance.',
    icon: therteen2,
  },
  {
    title: 'Warehouse/Supplier Dashboard',
    desc: 'Empower your partners with dedicated dashboards. Let warehouses and suppliers view stock levels, bills, and location details in real-time.',
    icon: therteen,
  },
];

export default function KeyFeatures() {
  return (
    <section className="container mx-auto px-5 mt-28">
      {/* Heading */}
      <h2 className="text-3xl font-bold text-center mb-12">Key Features</h2>

      {/* Grid */}
      <div className="grid gap-6 t:grid-cols-2 l:grid-cols-3">
        {features.map((item, i) => (
          <div
            key={i}
            className="bg-white shadow-md border rounded-xl p-5 flex items-start gap-4 hover:shadow-lg transition"
          >
            {/* Icon */}
            <div className="flex-shrink-0">
              <img
                src={item.icon}
                alt={item.title}
                className="h-16 w-16 object-contain"
              />
            </div>

            {/* Text */}
            <div>
              <h3 className="font-semibold text-lg mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
